// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/agents/agents.actions.go

import { type Scope } from "~/hooks/useScope";
import { DELETE_SERVICE_ACCOUNT } from "./action";

export function canDeleteServiceAccount(scope: Scope): boolean {
  return scope.iamActions.includes(DELETE_SERVICE_ACCOUNT);
}
